export default "__VITE_ASSET__B_QyV9AE__"